import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { ChartOptions } from "../../../../../shared/ChartOptions";
import { VIKDashbordClient } from "../../../../../web-api-client";

@Component({
  selector: 'app-tr-totals-new-Item',
  templateUrl: './tr-totals-new-Item.component.html',
  styleUrl: './tr-totals-new-Item.component.scss',
  changeDetection:ChangeDetectionStrategy.OnPush
})

export class TrTotalsNewItemComponent implements OnInit, OnChanges {

  @Input() isRefreshed: boolean = false;

  public totalRegisteredSignalsByYear: ChartOptions | any;


  public isLoading: boolean = true;
  public totalYearSignals: number[] = [];

  constructor(public readonly clinet: VIKDashbordClient,public readonly cdr:ChangeDetectorRef) {

  }

  ngOnInit(): void {
    this.loadData();
  }



  ngOnChanges(changes: SimpleChanges): void {
    // Check if isRefreshed has changed
    if (changes.isRefreshed && changes.isRefreshed.currentValue !== changes.isRefreshed.previousValue) {
      console.log('isRefreshed has changed to:', changes.isRefreshed.currentValue);
      // Perform the reload or the necessary actions here
      this.loadData();
    }
  }


  private loadData(): void {

    this.isLoading = true;

    let primary_color = localStorage.getItem('primary_color') || '#534686';
    let success_color = localStorage.getItem('success_color') || '#67C100';
    let secondary_color = localStorage.getItem('secondary_color') || '#FFA47A';

    this.clinet.getYearlyBasedTotalSignals().subscribe(items => {

      this.totalYearSignals = items.yearByMont;

      this.totalRegisteredSignalsByYear = {
        data: [],
        series: [
          {
            type: 'area',
            data: items.yearByMont,
          },
        ],
        chart: {
          height: 203,
          type: 'area',
          toolbar: {
            show: false,
          },
        },
        stroke: {
          curve: 'smooth',
          width: [5, 1],
          dashArray: [0, 5],
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.5,
            opacityTo: 0.9,
            stops: [0, 100],
          },
        },

        markers: {
          size: 0,
          colors: undefined,
          strokeColors: [primary_color],
          strokeWidth: [8, 0],
          strokeOpacity: 0.3,
          strokeDashArray: 0,
          fillOpacity: 1,
          discrete: [],
          shape: 'circle',
          radius: 2,
          offsetX: 0,
          offsetY: 0,
          onClick: undefined,
          onDblClick: undefined,
          showNullDataPoints: true,
          hover: {
            size: 7,
            sizeOffset: 3,
          },
        },
        responsive: [
          {
            breakpoint: 1401,
            options: {
              chart: {
                height: 210,
              },
            },
          },
          {
            breakpoint: 992,
            options: {
              chart: {
                height: 200,
              },
            },
          },
        ],
        yaxis: {
          show: false,
        },
        grid: {
          show: false,
        },
        xaxis: {
          show: false,
          labels: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          crosshairs: {
            show: true,
            width: 1,
            position: 'back',
            stroke: {
              color: primary_color,
              width: 1,
              dashArray: 5,
            },
          },
        },
        tooltip: {
          marker: {
            show: false,
          },
          fixed: {
            enabled: false,
            position: 'bottomRight',
            offsetX: 0,
            offsetY: 0,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        colors: [primary_color],
      };


      this.isLoading = false;
      this.cdr.detectChanges();

    })

  }
}
